module.exports = __webpack_public_path__ + "static/img/addwx_qrcode_1.acc8b0bb.png";